import Dispatcher from './Dispatcher';
import Constants from './Constants';

export default {
  getProducts(category = null) {
    Dispatcher.dispatch({
      actionType: Constants.GET_PRODUCTS,
      category
    });
  },

  getProduct(code, preset) {
		Dispatcher.dispatch({
			actionType: Constants.GET_PRODUCT,
			code,
      preset,
		});
	},

  setProduct(productCode, productSpecification) {
    Dispatcher.dispatch({
      actionType: Constants.SET_PRODUCT,
      productCode,
      productSpecification,
    });
  },

  getProductByHash(hash) {
    Dispatcher.dispatch({
      actionType: Constants.GET_PRODUCT_BY_HASH,
      hash,
    });
  },

  getPresets(code) {
    Dispatcher.dispatch({
      actionType: Constants.GET_PRESETS,
      code,
    });
  },

  getCustomProduct(hash) {
    Dispatcher.dispatch({
      actionType: Constants.GET_CUSTOM_PRODUCT,
      hash,
    });
  },

  createCustomProduct(specification, extra) {
    Dispatcher.dispatch({
      actionType: Constants.CREATE_CUSTOM_PRODUCT,
      specification,
      extra,
    });
  },

  updateCustomProduct(hash, specification) {
    Dispatcher.dispatch({
      actionType: Constants.UPDATE_CUSTOM_PRODUCT,
      hash,
      specification,
    });
  },

  updateCustomProductFit(hash, customFitted, size, sizeType) {
    Dispatcher.dispatch({
      actionType: Constants.UPDATE_CUSTOM_PRODUCT_FIT,
      hash,
      customFitted,
      size,
      sizeType
    });
  },

  bookAppointment(data) {
    Dispatcher.dispatch({
      actionType: Constants.BOOK_APPOINTMENT,
      data,
    })
  },

  getStores() {
    Dispatcher.dispatch({
      actionType: Constants.GET_STORES,
    });
  }

};



// WEBPACK FOOTER //
// ./src/flux/Actions.js